import type { FetchBaseQueryError } from "@reduxjs/toolkit/query/react";
import axios from "axios";
import { api } from "@/api/apiSlice";
import { backendBase } from "@/api/backendBase";
import type { Cin7ListResponse, Cin7Tax } from "@/api/dtos";
import type { Tax } from "./_models/Tax";
import { toTaxFromCin7Tax } from "./_transformers/toTaxFromCin7Tax";

type TaxListResponse = Cin7ListResponse<"TaxRuleList", Cin7Tax>;

const PAGE_LIMIT = 500;

/** Cin7 tax rules, first page (via the backend Cin7 proxy). */
export const getTaxListApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getTaxList: builder.query<Tax[], void>({
      queryFn: async () => {
        try {
          const res = await axios.get<TaxListResponse>(
            `${backendBase()}/cin7/tax-list`,
            {
              params: { Page: 1, Limit: PAGE_LIMIT },
              headers: { Accept: "application/json" },
            },
          );
          const taxes = res.data.TaxRuleList.map((x) => toTaxFromCin7Tax(x));
          return { data: taxes };
        }
        catch (e) {
          if (axios.isAxiosError(e) && e.response) {
            return {
              error: { status: e.response.status, data: e.response.data } as FetchBaseQueryError,
            };
          }
          return {
            error: { status: "FETCH_ERROR", error: String(e) } as FetchBaseQueryError,
          };
        }
      },
    }),
  }),
});

export const getTaxList = getTaxListApi.endpoints.getTaxList;
